import { Injectable } from '@angular/core';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';

@Injectable({ providedIn: 'root' })
export class OrganizationUnitProgramTemplateBundleService {
  constructor(private $baseApi: DoenKidsGenericApiProvider) {}

  update(organizationUnitId: number, programTemplateBundleId: number, organizationUnitRoleId: number) {
    // eslint-disable-next-line max-len
    return this.$baseApi.genericPutCall(`/customer/organization-unit/${organizationUnitId}/program-template-bundle/${programTemplateBundleId}?organizationUnitRoleId=${organizationUnitRoleId}`);
  }

  archive(organizationUnitId: number, programTemplateBundleId: number) {
    return this.$baseApi.genericDeleteCall(`/customer/organization-unit/${organizationUnitId}/program-template-bundle/${programTemplateBundleId}`);
  }
}
